import { render, staticRenderFns } from "./AccountantCostTable.vue?vue&type=template&id=63cbe5c8&scoped=true&"
import script from "./AccountantCostTable.vue?vue&type=script&lang=js&"
export * from "./AccountantCostTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountantCostTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AccountantCostTable.vue?vue&type=style&index=1&id=63cbe5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cbe5c8",
  null
  
)

export default component.exports